export default (authentication) => String(authentication).split(".").length === 3